export enum MfaMethod {
  'email',
  'totp'
}
